export default "__VITE_ASSET__8cfcd3ee__"